import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import Header from './header/Header.ianua';
import PageNavigation from './sidebar/PageNavigation';

type PageProps = PropsWithChildren;

export default function Page({ children }: PageProps) {
  return (
    <div className={classNames('page')}>
      <PageNavigation />
      <Header />
      <div className="main-layout">
        <div className="content-layout">
          <main>
            <div className="margin-wrapper">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
}
